module.exports = "/_next/static/images/game-1-phone-uv-lock-5-3b13d87127d5acfd5fe059a7a1011025.png";